<template>
  <div>
    <h3 class="text-primary font-weight-bold f-s-30 l-h-20 grey-dark m-b-50">
      Related Post
    </h3>
    <b-row>
      <Loading v-if="loading" />
      <b-col
        v-for="(post, i) in relatedPosts"
        v-else
        :key="i"
        class="mb-3"
        lg="4"
        sm="12"
      >
        <RelatedPostItem
          :blog="post"
          @get-data="$emit('get-data')"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import RelatedPostItem from '@/components/Blog/RelatedPostItem';
import Loading from '@/components/Loading';

export default {
  name: 'RelatedPost',
  components: { Loading, RelatedPostItem },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      relatedPosts: (state) => state.blog.relatedPosts,
    }),
  },
  async created() {
    this.loading = true;
    await this.getRelatedPosts(this.id)
      .then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions([
      'getRelatedPosts',
    ]),
  },
};
</script>
